// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"68":"a938ddbe","153":"35fdb088","226":"165237d3","237":"22271722","283":"7de01402","337":"60faf63b","353":"0c6dbf92","420":"aa1986c5","479":"d6883484","523":"0d74b880","714":"2531de4a","851":"4d87ef8d","988":"f1bebc6a"}[chunkId] + ".chunk.js";
};